<template>
  <modal v-on:closeModalRequest="closeModalRequest()">
    <div v-if="oldEmail" class="modal-email-changed scrollable -y">
      <div class="header">
        <div class="title">Your Account Email Changed</div>
        <div class="description">Please be aware that your account email has been changed.</div>
      </div>
      <form
      v-on:submit="onClickSubmit"
      class="body">
        <div class="content">
          <div class="info-container">
            <div class="table">
              <div class="tr" style="background-color: hsla(0, 0%, 75%, 1);">
                <div class="td title">Old Email</div>
                <div class="td">{{oldEmail}}</div>
              </div>
              <div class="tr" style="background-color: hsla(202, 100%, 40%, 1);">
                <div class="td title">New Email</div>
                <div class="td">{{myEmail}}</div>
              </div>
            </div>
          </div>
          <div class="action-btns">
            <input
            id="email-changed-confirm"
            type="submit" value="Got it"
            class="action-btn blue" />
          </div>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  name: 'modal-email-changed',
  components: {
    Modal
  },
  computed: {
    myEmail: function () {
      return this.$store.getters.myEmail
    }
  },
  data: function () {
    return {
      oldEmail: null
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init: function () {
      this.oldEmail = this.$param.options['oldEmail']
      if (!this.oldEmail) this.closeModalRequestWithoutRemovingQuery()
    },
    closeModalRequestWithoutRemovingQuery: function () {
      this.$emit('closeModalRequest')
    },
    closeModalRequest: function () {
      this.$emit('closeModalRequest')
      this.goToProfile()
    },
    onClickSubmit: function (e) {
      e.preventDefault()
      this.closeModalRequest()
    },
    goToProfile: function () {
      this.$router.push({name: 'Profile'})
    }
  }
}
</script>

<style scoped>
.modal-email-changed {
  /* common */
  background-color: hsla(0, 100%, 100%, 1);
  font-size: 11px;
  border-radius: 5px;
  /* size */
  max-width: 500px;
  max-height: 100%;
  width: 100%;
}

.modal-email-changed .header {
  /* common */
  font-size: 14px;
  /* size */
  padding: 20px 16px 20px;
  /* text */
  font-weight: bold;
  /* alignment */
  text-align: left;
}
.modal-email-changed .header .title {
  /* common */
  font-size: 2em;
}
.modal-email-changed .header .description {
  /* common */
  font-size: 1em;
  /* text */
  font-weight: normal;
}

.modal-email-changed .body {
  /* size */
  padding: 0 16px;
  /* border */
  border-top: 1px solid hsla(0, 100%, 0%, 0.1);
  /* alignment */
  text-align: left;
}

.modal-email-changed .body .content {
  /* common */
  color: #000;
  font-size: 16px;
  /* size */
  width: 100%;
  min-height: 4em;
  margin: 16px 0;
  /* border */
  /* outline: 1px solid red; */
}


.modal-email-changed .body .content .info-container:first-child {
  margin-top: 0;
}
.modal-email-changed .body .content .info-container {
  /* size */
  margin: 1em 0;
}

.modal-email-changed .body .content .info-container .table {
  /* size */
  width: calc(100% - 2px);
  border: 1px solid hsla(0,0%,0%,0.5);
  /* alignment */
  display: table;
}
.modal-email-changed .body .content .info-container .table .tr {
  /* alignment */
  display: table-row;
}
.modal-email-changed .body .content .info-container .table .td {
  /* common */
  color: #fff;
  /* size */
  padding: 0.5em;
  /* text */
  font-weight: bold;
  /* alignment */
  display: table-cell;
}
.modal-email-changed .body .content .info-container .table .td.title {
  /* common */
  font-size: 0.8em;
  border-right: 1px solid hsla(0,0%,0%,0.1);
  background-color: hsla(0,0%,0%,0.1);
  /* text */
  text-transform: uppercase;
}


.modal-email-changed .body .content .action-btns {
  /* size */
  margin: 1em 0 2em;
  /* alignment */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

</style>



// WEBPACK FOOTER //
// src/components/Modal/ModalEmailChanged.vue